import type { PropsWithChildren } from "react";
import { COMPANY_NAME, COMPANY_SITE } from "../config";
import { useAuth } from "../auth/auth-context";
import { AppLink } from "../router";
import legalFlowLogo from "../assets/legalflow-logo.svg";

export function Brand() {
  return (
    <AppLink href="/" className="brand" aria-label="LegalFlow, inicio">
      <span className="brand__logo-shell" aria-hidden="true">
        <img className="brand__logo" src={legalFlowLogo} alt="" />
      </span>
      <small className="brand__descriptor">Calculadora laboral</small>
    </AppLink>
  );
}

export function Layout({ children }: PropsWithChildren) {
  const { user, loading, enabled, signIn, signOut } = useAuth();
  return (
    <div className="site-shell">
      <header className="site-header">
        <div className="site-header__inner">
          <Brand />
          <nav className="site-nav" aria-label="Navegación principal">
            <AppLink href="/">Calcular</AppLink>
            <AppLink href="/mis-calculos">Mis cálculos</AppLink>
            <AppLink href="/metodologia">Metodología</AppLink>
          </nav>
          <div className="account">
            {loading ? (
              <span className="account__status">Cargando…</span>
            ) : user ? (
              <>
                <span className="account__email">
                  {String(user.profile.email || "Mi cuenta")}
                </span>
                <button className="button button--ghost button--small" onClick={() => void signOut()}>
                  Salir
                </button>
              </>
            ) : (
              <button
                className="button button--outline button--small"
                disabled={!enabled}
                title={
                  enabled
                    ? "Inicia sesión para guardar cálculos"
                    : "La cuenta se habilitará al desplegar la infraestructura AWS"
                }
                onClick={() => void signIn()}
              >
                Guardar mis cálculos
              </button>
            )}
          </div>
        </div>
      </header>
      <main>
        {children}
      </main>
      <footer className="site-footer">
        <div>
          <Brand />
          <p>Herramienta informativa gratuita de {COMPANY_NAME}</p>
        </div>
        <nav aria-label="Información legal">
          <AppLink href="/privacidad">Aviso de privacidad</AppLink>
          <AppLink href="/terminos">Términos de uso</AppLink>
          <a href={COMPANY_SITE} target="_blank" rel="noreferrer">
            legalflow.solutions
          </a>
        </nav>
        <p className="site-footer__copy">© 2026 LegalFlow</p>
      </footer>
    </div>
  );
}
